// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.roulette {
    /*margin: 40px;*/
    /*padding: 40px;*/

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    perspective: 1000px; /* задаем перспективу */
      transform-style: preserve-3d; /* сохраняем 3D пространство */

    font-family: 'Poppins', sans-serif;
    rotate: 0deg;


    /*font-weight: 500;*/
}

.roulette table {
    float: left;

}
@keyframes fadeIn {
    from {
        opacity: 0;
        
    }
    to {
        opacity: 1;
        
    }
}
.infoKoefsRoulette{
    
    
    display: flex;
    flex-direction: column;
    align-items: center;
    
    
    
    
    text-align: center;
    z-index: 10;
    gap: 5px;
    background-color: rgba(17,23,32,.75);
    color:white;
    padding: 10px;
    border-radius: 10px;
    margin-bottom: 5px;
    animation: fadeIn 1.5s ease-in-out; /* Длительность 1 секунда с плавным входом и выходом */

}

.roulette table,
tr {
    border-collapse: collapse;
}
.roulette table{


    table-layout: fixed;

    /*transform: rotateX(36deg) scaleY(.9) translate3d(0,-5rem,-5rem);*/
    transition: transform .8s linear;

}
.roulette table.rotate{
    opacity: 0.5;
    transform: rotateX(36deg) scaleY(.9) translate3d(0,-5rem,-5rem);
    transition: transform .8s linear;
}
.roulette table.unrotate{

    transform: rotateX(0deg) scaleY(1) translateZ(0);
    transition: transform .8s linear;
}
.roulette td {

    border-spacing: 0;
    border-collapse: collapse;
    border: 1px solid black;
    width: 60px;
    height: 60px;
    text-align: center;
    vertical-align: middle;

    font-size: 18px;
    color: white;
    white-space: nowrap;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */ /* Konqueror HTML */ /* Old versions of Firefox */ /* Internet Explorer/Edge */
    user-select: none;
}

/* elements */
.roulette .sector {
    background: #191d3e; /* фиолетовый */
    color: whitesmoke;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */ /* Konqueror HTML */ /* Old versions of Firefox */ /* Internet Explorer/Edge */
    user-select: none;
}
.imgChoice{
    max-width: 100px;
    height: auto; /* Сохраняем пропорции изображения */
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */ /* Konqueror HTML */ /* Old versions of Firefox */ /* Internet Explorer/Edge */
    user-select: none;
    pointer-events: none; /* Отключение взаимодействия с изображением */
}


.roulette .num {
    font-size: 22px;
}

.roulette .num span {
    display: block;

}
.sector{
    cursor: pointer;
}
.roulette .zero {

    cursor: pointer;
    width: 120px;
    background-color: #191d3e;
}

.roulette .empty {
    border: none;
    border-bottom: 0!important;
}

/* colors */
.roulette .green {
    cursor: pointer;

    background: #191d3e; /* фиолетовый */
    color: whitesmoke;
}

.roulette .red {
    cursor: pointer;
    background-color: #960505;
    color: white;
    transition: background-color 0.5s ease, color 0.5s ease; /* Добавляем переход для background-color и color */

}
.roulette table.rotate{
    pointer-events: none;
}
img{
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */ /* Konqueror HTML */ /* Old versions of Firefox */ /* Internet Explorer/Edge */
    user-select: none;
}
.roulette .img-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}

.roulette .black {
    cursor: pointer;

    background-color: #043186;
    color: white;
    transition: background-color 0.5s ease, color 0.5s ease; /* Добавляем переход для background-color и color */

}
.red.hover{
    background-color: rgba(155,5,5,0.4);
    transition: background-color 0.5s ease;
    color: #07da4a;
}
.black.hover{
    background-color:rgba(4,49,134,0.4);
    transition: background-color 0.5s ease;
    color: #07da4a;
}
.black:hover{
    background-color:rgba(4,49,134,0.4);
    transition: background-color 0.5s ease;
    color: #07da4a;
}
.red:hover{

    background-color: rgba(155,5,5,0.4);
    transition: background-color 0.5s ease;
    color: #07da4a;


}

/* cells hovers */

/* orientation */
.roulette .vt {

    display: block;
    transform: rotate(270deg);
    white-space: nowrap;
}




.hidden {
    display: none;
}
@media only screen and (max-width: 746px) and(min-height: 654px) {

    .imgChoice{
        width: 70%;
    }
    .roulette td{
        width: 50px;
        height: 50px;
        font-size: 13px;
    }
    .roulette .num {
        font-size: 13px;
    }
}
@media only screen and (max-width: 1000px) {
    .roulette{
        max-width: 500px
    }
    .table-wrapper {
        display: block;
        width: 100%;
    }

    .roulette table {
        width: 100%;

    }
    .roulette .num{
        font-size:15px;
    }
    .roulette .num{

        
        

    }
    .roulette .zero{
        width: 60px;
        height: 30px;
    }
    .sector span{
        font-size: 12px;
    }
    .roulette .zero img{

        max-width: 30px;
    }

    .sector img{
        max-width: 60px;
    }
    .roulette td {
        width: 30px; /* Уменьшаем ширину ячеек */
        height: 30px; /* Уменьшаем высоту ячеек */
        font-size: 10px; /* Уменьшаем размер шрифта в ячейках */
    }
    .roulette .zero {
        width: 60px; /* Меняем ширину ячейки с классом .zero */
        height: 30px; /* Меняем высоту ячейки с классом .zero */
    }

    .roulette .zero img,
    .sector img {
        max-width: 60px; /* Уменьшаем максимальную ширину изображений */
    }


    .roulette{

        margin-top: 100px;
        rotate: 90deg;


    }
    .roulette .vt {
        display: flex;
        justify-content: center;
        margin: 0 0;
        transform: rotate(0deg);
        white-space: nowrap;
    }
    .sector span{
        display: flex;
        margin: 0 0;
        justify-content: center;
    }
    .roulette .num span {
        display: flex;
        justify-content: center;
        transform: rotate(270deg);
    }
    .imgChoice{
        transform: rotate(-90deg);
    }

    td.sector {
        height: 60px;
    }
    .roulette table{
        margin:0;
    }
    .sector span{
        display: block;

        rotate: -90deg;
        white-space: nowrap;

    }


}
@media screen and (max-width: 973px) and (min-width: 730px) {
    .roulette table {
        width: 100%;

    }
    .roulette td{
        width: 40px;
        height: 40px;

    }
    .roulette .zero{
        width: 60px;
    }
    .sector span{
        font-size: 15px;
    }
    .roulette .zero img{

        max-width: 80px;
    }

    .sector img{
        max-width: 80px;
    }
}
@media screen and (max-width: 730px) and (min-width: 653px) {
    .roulette table {
        width: 100%;

    }
    .roulette .num{
        font-size:15px;
    }
    .roulette td{
        width: 35px;
        height: 35px;

    }
    .roulette .zero{
        width: 60px;
    }
    .sector span{
        font-size: 15px;
    }
    .roulette .zero img{

        max-width: 70px;
    }

    .sector img{
        max-width: 80px;
    }
}
@media screen {
    
}`, "",{"version":3,"sources":["webpack://./src/components/UI/TableBets/index.css"],"names":[],"mappings":";;AAEA;IACI,gBAAgB;IAChB,iBAAiB;;IAEjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB,EAAE,uBAAuB;MAC1C,4BAA4B,EAAE,8BAA8B;;IAE9D,kCAAkC;IAClC,YAAY;;;IAGZ,oBAAoB;AACxB;;AAEA;IACI,WAAW;;AAEf;AACA;IACI;QACI,UAAU;;IAEd;IACA;QACI,UAAU;;IAEd;AACJ;AACA;;;IAGI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;;;;;IAKnB,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,oCAAoC;IACpC,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kCAAkC,EAAE,sDAAsD;;AAE9F;;AAEA;;IAEI,yBAAyB;AAC7B;AACA;;;IAGI,mBAAmB;;IAEnB,mEAAmE;IACnE,gCAAgC;;AAEpC;AACA;IACI,YAAY;IACZ,+DAA+D;IAC/D,gCAAgC;AACpC;AACA;;IAEI,gDAAgD;IAChD,gCAAgC;AACpC;AACA;;IAEI,iBAAiB;IACjB,yBAAyB;IACzB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;;IAEtB,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,2BAA2B,EAAE,eAAe;IAC5C,yBAAyB,EAAE,WAAW,EACZ,mBAAmB,EACrB,4BAA4B,EAC7B,2BAA2B;IAClD,iBAAiB;AACrB;;AAEA,aAAa;AACb;IACI,mBAAmB,EAAE,eAAe;IACpC,iBAAiB;IACjB,2BAA2B,EAAE,eAAe;IAC5C,yBAAyB,EAAE,WAAW,EACZ,mBAAmB,EACrB,4BAA4B,EAC7B,2BAA2B;IAClD,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,YAAY,EAAE,oCAAoC;IAClD,2BAA2B,EAAE,eAAe;IAC5C,yBAAyB,EAAE,WAAW,EACZ,mBAAmB,EACrB,4BAA4B,EAC7B,2BAA2B;IAClD,iBAAiB;IACjB,oBAAoB,EAAE,6CAA6C;AACvE;;;AAGA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;;AAElB;AACA;IACI,eAAe;AACnB;AACA;;IAEI,eAAe;IACf,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,0BAA0B;AAC9B;;AAEA,WAAW;AACX;IACI,eAAe;;IAEf,mBAAmB,EAAE,eAAe;IACpC,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,uDAAuD,EAAE,mDAAmD;;AAEhH;AACA;IACI,oBAAoB;AACxB;AACA;IACI,2BAA2B,EAAE,eAAe;IAC5C,yBAAyB,EAAE,WAAW,EACZ,mBAAmB,EACrB,4BAA4B,EAC7B,2BAA2B;IAClD,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;;IAEf,yBAAyB;IACzB,YAAY;IACZ,uDAAuD,EAAE,mDAAmD;;AAEhH;AACA;IACI,mCAAmC;IACnC,sCAAsC;IACtC,cAAc;AAClB;AACA;IACI,mCAAmC;IACnC,sCAAsC;IACtC,cAAc;AAClB;AACA;IACI,mCAAmC;IACnC,sCAAsC;IACtC,cAAc;AAClB;AACA;;IAEI,mCAAmC;IACnC,sCAAsC;IACtC,cAAc;;;AAGlB;;AAEA,iBAAiB;;AAEjB,gBAAgB;AAChB;;IAEI,cAAc;IACd,yBAAyB;IACzB,mBAAmB;AACvB;;;;;AAKA;IACI,aAAa;AACjB;AACA;;IAEI;QACI,UAAU;IACd;IACA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI;IACJ;IACA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,WAAW;;IAEf;IACA;QACI,cAAc;IAClB;IACA;;;;;IAKA;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,eAAe;IACnB;IACA;;QAEI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;IACA;QACI,WAAW,EAAE,2BAA2B;QACxC,YAAY,EAAE,2BAA2B;QACzC,eAAe,EAAE,sCAAsC;IAC3D;IACA;QACI,WAAW,EAAE,yCAAyC;QACtD,YAAY,EAAE,yCAAyC;IAC3D;;IAEA;;QAEI,eAAe,EAAE,8CAA8C;IACnE;;;IAGA;;QAEI,iBAAiB;QACjB,aAAa;;;IAGjB;IACA;QACI,aAAa;QACb,uBAAuB;QACvB,WAAW;QACX,uBAAuB;QACvB,mBAAmB;IACvB;IACA;QACI,aAAa;QACb,WAAW;QACX,uBAAuB;IAC3B;IACA;QACI,aAAa;QACb,uBAAuB;QACvB,yBAAyB;IAC7B;IACA;QACI,yBAAyB;IAC7B;;IAEA;QACI,YAAY;IAChB;IACA;QACI,QAAQ;IACZ;IACA;QACI,cAAc;;QAEd,cAAc;QACd,mBAAmB;;IAEvB;;;AAGJ;AACA;IACI;QACI,WAAW;;IAEf;IACA;QACI,WAAW;QACX,YAAY;;IAEhB;IACA;QACI,WAAW;IACf;IACA;QACI,eAAe;IACnB;IACA;;QAEI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,WAAW;;IAEf;IACA;QACI,cAAc;IAClB;IACA;QACI,WAAW;QACX,YAAY;;IAEhB;IACA;QACI,WAAW;IACf;IACA;QACI,eAAe;IACnB;IACA;;QAEI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;AACA;;AAEA","sourcesContent":["\n\n.roulette {\n    /*margin: 40px;*/\n    /*padding: 40px;*/\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    perspective: 1000px; /* задаем перспективу */\n      transform-style: preserve-3d; /* сохраняем 3D пространство */\n\n    font-family: 'Poppins', sans-serif;\n    rotate: 0deg;\n\n\n    /*font-weight: 500;*/\n}\n\n.roulette table {\n    float: left;\n\n}\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        \n    }\n    to {\n        opacity: 1;\n        \n    }\n}\n.infoKoefsRoulette{\n    \n    \n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    \n    \n    \n    \n    text-align: center;\n    z-index: 10;\n    gap: 5px;\n    background-color: rgba(17,23,32,.75);\n    color:white;\n    padding: 10px;\n    border-radius: 10px;\n    margin-bottom: 5px;\n    animation: fadeIn 1.5s ease-in-out; /* Длительность 1 секунда с плавным входом и выходом */\n\n}\n\n.roulette table,\ntr {\n    border-collapse: collapse;\n}\n.roulette table{\n\n\n    table-layout: fixed;\n\n    /*transform: rotateX(36deg) scaleY(.9) translate3d(0,-5rem,-5rem);*/\n    transition: transform .8s linear;\n\n}\n.roulette table.rotate{\n    opacity: 0.5;\n    transform: rotateX(36deg) scaleY(.9) translate3d(0,-5rem,-5rem);\n    transition: transform .8s linear;\n}\n.roulette table.unrotate{\n\n    transform: rotateX(0deg) scaleY(1) translateZ(0);\n    transition: transform .8s linear;\n}\n.roulette td {\n\n    border-spacing: 0;\n    border-collapse: collapse;\n    border: 1px solid black;\n    width: 60px;\n    height: 60px;\n    text-align: center;\n    vertical-align: middle;\n\n    font-size: 18px;\n    color: white;\n    white-space: nowrap;\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Safari */\n    -khtml-user-select: none; /* Konqueror HTML */\n    -moz-user-select: none; /* Old versions of Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none;\n}\n\n/* elements */\n.roulette .sector {\n    background: #191d3e; /* фиолетовый */\n    color: whitesmoke;\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Safari */\n    -khtml-user-select: none; /* Konqueror HTML */\n    -moz-user-select: none; /* Old versions of Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none;\n}\n.imgChoice{\n    max-width: 100px;\n    height: auto; /* Сохраняем пропорции изображения */\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Safari */\n    -khtml-user-select: none; /* Konqueror HTML */\n    -moz-user-select: none; /* Old versions of Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none;\n    pointer-events: none; /* Отключение взаимодействия с изображением */\n}\n\n\n.roulette .num {\n    font-size: 22px;\n}\n\n.roulette .num span {\n    display: block;\n\n}\n.sector{\n    cursor: pointer;\n}\n.roulette .zero {\n\n    cursor: pointer;\n    width: 120px;\n    background-color: #191d3e;\n}\n\n.roulette .empty {\n    border: none;\n    border-bottom: 0!important;\n}\n\n/* colors */\n.roulette .green {\n    cursor: pointer;\n\n    background: #191d3e; /* фиолетовый */\n    color: whitesmoke;\n}\n\n.roulette .red {\n    cursor: pointer;\n    background-color: #960505;\n    color: white;\n    transition: background-color 0.5s ease, color 0.5s ease; /* Добавляем переход для background-color и color */\n\n}\n.roulette table.rotate{\n    pointer-events: none;\n}\nimg{\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Safari */\n    -khtml-user-select: none; /* Konqueror HTML */\n    -moz-user-select: none; /* Old versions of Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none;\n}\n.roulette .img-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n}\n\n.roulette .black {\n    cursor: pointer;\n\n    background-color: #043186;\n    color: white;\n    transition: background-color 0.5s ease, color 0.5s ease; /* Добавляем переход для background-color и color */\n\n}\n.red.hover{\n    background-color: rgba(155,5,5,0.4);\n    transition: background-color 0.5s ease;\n    color: #07da4a;\n}\n.black.hover{\n    background-color:rgba(4,49,134,0.4);\n    transition: background-color 0.5s ease;\n    color: #07da4a;\n}\n.black:hover{\n    background-color:rgba(4,49,134,0.4);\n    transition: background-color 0.5s ease;\n    color: #07da4a;\n}\n.red:hover{\n\n    background-color: rgba(155,5,5,0.4);\n    transition: background-color 0.5s ease;\n    color: #07da4a;\n\n\n}\n\n/* cells hovers */\n\n/* orientation */\n.roulette .vt {\n\n    display: block;\n    transform: rotate(270deg);\n    white-space: nowrap;\n}\n\n\n\n\n.hidden {\n    display: none;\n}\n@media only screen and (max-width: 746px) and(min-height: 654px) {\n\n    .imgChoice{\n        width: 70%;\n    }\n    .roulette td{\n        width: 50px;\n        height: 50px;\n        font-size: 13px;\n    }\n    .roulette .num {\n        font-size: 13px;\n    }\n}\n@media only screen and (max-width: 1000px) {\n    .roulette{\n        max-width: 500px\n    }\n    .table-wrapper {\n        display: block;\n        width: 100%;\n    }\n\n    .roulette table {\n        width: 100%;\n\n    }\n    .roulette .num{\n        font-size:15px;\n    }\n    .roulette .num{\n\n        \n        \n\n    }\n    .roulette .zero{\n        width: 60px;\n        height: 30px;\n    }\n    .sector span{\n        font-size: 12px;\n    }\n    .roulette .zero img{\n\n        max-width: 30px;\n    }\n\n    .sector img{\n        max-width: 60px;\n    }\n    .roulette td {\n        width: 30px; /* Уменьшаем ширину ячеек */\n        height: 30px; /* Уменьшаем высоту ячеек */\n        font-size: 10px; /* Уменьшаем размер шрифта в ячейках */\n    }\n    .roulette .zero {\n        width: 60px; /* Меняем ширину ячейки с классом .zero */\n        height: 30px; /* Меняем высоту ячейки с классом .zero */\n    }\n\n    .roulette .zero img,\n    .sector img {\n        max-width: 60px; /* Уменьшаем максимальную ширину изображений */\n    }\n\n\n    .roulette{\n\n        margin-top: 100px;\n        rotate: 90deg;\n\n\n    }\n    .roulette .vt {\n        display: flex;\n        justify-content: center;\n        margin: 0 0;\n        transform: rotate(0deg);\n        white-space: nowrap;\n    }\n    .sector span{\n        display: flex;\n        margin: 0 0;\n        justify-content: center;\n    }\n    .roulette .num span {\n        display: flex;\n        justify-content: center;\n        transform: rotate(270deg);\n    }\n    .imgChoice{\n        transform: rotate(-90deg);\n    }\n\n    td.sector {\n        height: 60px;\n    }\n    .roulette table{\n        margin:0;\n    }\n    .sector span{\n        display: block;\n\n        rotate: -90deg;\n        white-space: nowrap;\n\n    }\n\n\n}\n@media screen and (max-width: 973px) and (min-width: 730px) {\n    .roulette table {\n        width: 100%;\n\n    }\n    .roulette td{\n        width: 40px;\n        height: 40px;\n\n    }\n    .roulette .zero{\n        width: 60px;\n    }\n    .sector span{\n        font-size: 15px;\n    }\n    .roulette .zero img{\n\n        max-width: 80px;\n    }\n\n    .sector img{\n        max-width: 80px;\n    }\n}\n@media screen and (max-width: 730px) and (min-width: 653px) {\n    .roulette table {\n        width: 100%;\n\n    }\n    .roulette .num{\n        font-size:15px;\n    }\n    .roulette td{\n        width: 35px;\n        height: 35px;\n\n    }\n    .roulette .zero{\n        width: 60px;\n    }\n    .sector span{\n        font-size: 15px;\n    }\n    .roulette .zero img{\n\n        max-width: 70px;\n    }\n\n    .sector img{\n        max-width: 80px;\n    }\n}\n@media screen {\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
